
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dao/[symbol]/treasury/governance/[governanceId]/edit",
      function () {
        return require("private-next-pages/dao/[symbol]/treasury/governance/[governanceId]/edit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dao/[symbol]/treasury/governance/[governanceId]/edit"])
      });
    }
  